function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.921 8c0-.276.106-.552.316-.763L8.474 0 10 1.526 3.526 8 10 14.474 8.474 16 1.237 8.763A1.076 1.076 0 01.921 8z",
  fill: "#545C52"
});

function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,ICAgIDxzdmcKICAgICAgICAgICAgICAgICAgICB2aWV3Qm94PSIwIDAgMTAgMTYiCiAgICAgICAgICAgICAgICAgICAgICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgICAgICAgICAgICAgICAgICAgPgogICAgICAgICAgICAgICAgICAgICAgPHBhdGgKICAgICAgICAgICAgICAgICAgICAgICAgZD0iTS45MjEgOGMwLS4yNzYuMTA2LS41NTIuMzE2LS43NjNMOC40NzQgMCAxMCAxLjUyNiAzLjUyNiA4IDEwIDE0LjQ3NCA4LjQ3NCAxNiAxLjIzNyA4Ljc2M0ExLjA3NiAxLjA3NiAwIDAgMSAuOTIxIDh6IgogICAgICAgICAgICAgICAgICAgICAgICBmaWxsPSIjNTQ1QzUyIgogICAgICAgICAgICAgICAgICAgICAgLz4KICAgICAgICAgICAgICAgICAgICA8L3N2Zz4=";
export { SvgArrowLeft as ReactComponent };